import { AxiosResponse } from "axios";
import { AliasViewModel } from "../aliases/AliasStore";
import axios, { APIWrapperResponse, DefaultResponse, TypedResponse } from "../general/HttpClient";

export function RedeemBadge(badgeID): Promise<DefaultResponse> {
    return axios.post(`/api/Badge/RedeemBadge/` + badgeID).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function RedeemParticipationBadge(badgeID): Promise<DefaultResponse> {
    return axios.post(`/api/Badge/RedeemParticipationBadge/` + badgeID).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function GetBadge(id: string): Promise<TypedResponse<BadgeViewModel>> {
    return axios.get(`/api/Badge/GetBadge`, { params: { id } }).then((response: AxiosResponse<APIWrapperResponse<TypedResponse<BadgeViewModel>>>) => {
        return response.data.result;
    });
}

export function GetBadgeInstance(id: string): Promise<TypedResponse<AliasBadgeViewModel>> {
    return axios.get(`/api/Badge/GetBadgeInstance`, { params: { id } }).then((response: AxiosResponse<APIWrapperResponse<TypedResponse<AliasBadgeViewModel>>>) => {
        return response.data.result;
    });
}
export function ListBadge(skip: number, limit: number): Promise<TypedResponse<BadgeViewModel[]>> {
    return axios.get(`/api/Badge/ListBadge`, { params: { skip, limit } }).then((response: AxiosResponse<APIWrapperResponse<TypedResponse<BadgeViewModel[]>>>) => {
        return response.data.result;
    });
}
export function ListBlanks(): Promise<TypedResponse<AliasBadgeViewModel[]>> {
    return axios.get(`/api/Badge/ListBlanks`).then((response: AxiosResponse<APIWrapperResponse<TypedResponse<AliasBadgeViewModel[]>>>) => {
        return response.data.result;
    });
}
export function CreateBadge(request: CreateBadgeRequest): Promise<DefaultResponse> {
    return axios.post(`/api/Badge/CreateBadge`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function UpdateBadge(request: UpdateBadgeRequest): Promise<DefaultResponse> {
    return axios.put(`/api/Badge/UpdateBadge`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function DeleteBadge(id: string): Promise<DefaultResponse> {
    return axios.delete(`/api/Badge/DeleteBadge/${id}`).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function AwardBadge(badgeId: string, aliasId: string): Promise<DefaultResponse> {
    return axios.post(`/api/Badge/AwardBadge/${badgeId}/${aliasId}`).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function RevokeBadge(badgeId: string, aliasId: string): Promise<DefaultResponse> {
    return axios.delete(`/api/Badge/RevokeBadge/${badgeId}/${aliasId}`).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function CreateFullBlanks(count: number): Promise<DefaultResponse> {
    return axios.post(`/api/Badge/CreateBlanks/`, { count }).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function CreateBlanks(badgeId: string, count: number): Promise<DefaultResponse> {
    return axios.post(`/api/Badge/CreateBlanks/${badgeId}`, { count }).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function AssignBadge(badgeID, badgeInstanceID): Promise<DefaultResponse> {
    return axios.post(`/api/Badge/AssignBadge/` + badgeID, {}, { params: { badgeInstanceID } }).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export interface BadgeViewModel {
    id: string;
    name: string;
    description: string;
    logoURI: string;
    blanks: AliasBadgeViewModel[];
    isParticipationBadge: boolean;
}

export interface CreateBadgeRequest {
    name: string;
    description: string;
    logoUri: string;
    logoContent: string;
    isParticipationBadge: boolean;
}

export interface AliasBadgeViewModel {
    id: string;
    aliasID: string;
    alias: AliasViewModel;
    badgeID: string;
    badge: BadgeViewModel;
    awardedOn: string;
}

export interface UpdateBadgeRequest {
    iD: string;
    name: string;
    description: string;
    logoURI: string;
    logoContent: string;
    isParticipationBadge: boolean;
}
